// import router from 'vue-router'
import axios from 'axios';
import Vue from 'vue';

const actions = {
    getAll: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const document_category_id = payload.document_category_id;
        const employment_id = payload.employment_id;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/documents', {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                    document_category_id: document_category_id,
                    employment_id: employment_id
                }
            }
          ).then(res => {
            return res
          }).catch((err) => {
            return err
        });
    },
    getDocument: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const id = payload.id;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/documents/' + id, {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
          ).then(res => {
            return res
          }).catch((err) => {
            return err
        });
    },
    downloadDocument: ({commit}, payload) => {
      const ApiClient = payload.ApiClient;
      const departments = payload.departments;
      const hash = payload.hash;

      return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/document/' + hash + '/download', {
              responseType: 'blob',
              params: {
                  firebaseIdToken: ApiClient.token,
                  departments: departments,
              }
          }
        ).then(res => {
          return res
        }).catch((err) => {
          return err
      });
    },
    getCategories: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/documents/categories', {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
          ).then(res => {
            return res
          }).catch((err) => {
            return err
        });
    },
    createDocument: ({commit}, payload) => {
      const ApiClient = payload.ApiClient;
      const departments = payload.departments;
      const documentCategoryId = payload.documentCategoryId;
      const employmentId = payload.employmentId;
      const file = payload.file;

      const formData = new FormData();
      formData.append("document_category_id", documentCategoryId);
      formData.append("employment_id", employmentId);
      formData.append("file", file);

      return axios.post(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/documents', 
        formData,
        {
            params: {
                firebaseIdToken: ApiClient.token,
                departments: departments,
            }
        }
      ).then(res => {
      return res
      }).catch((err) => {
      return err
      });
    },
    createDocumentBatch: ({commit}, payload) => {
      // employmentId expected to be an array
      const ApiClient = payload.ApiClient;
      const departments = payload.departments;
      const documentCategoryId = payload.documentCategoryId;
      const employmentId = payload.employmentId;
      const file = payload.file;

      const formData = new FormData();
      formData.append("document_category_id", documentCategoryId);
      for(let i in employmentId) {
        formData.append("employment_id[]", employmentId[i]);
      }
      formData.append("file", file);

      return axios.post(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/documents/batch', 
        formData,
        {
            params: {
                firebaseIdToken: ApiClient.token,
                departments: departments,
            }
        }
      ).then(res => {
      return res
      }).catch((err) => {
      return err
      });
    },
    download: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const hash = payload.hash;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/document/' + hash + '/download', {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
          ).then(res => {
            return res
          }).catch((err) => {
            return err
        });
    },
}

export default actions
